import { Button, Typography } from '@mui/material';
import { useState } from 'react';
import api from '../../services/api';
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import MessageSuccess from '../../messages/messageSuccess';
import MessageError from '../../messages/messageError';
import FichaRepresentante from '../gestRepresentantes/fichaRepresentante';
import StepCadastroRepresentante from '../departamentos/dlif/licenciamento/cadastroEstabelecimento/stepsFormularios/stepCadastroRepresentante';
import ButtonLeft from '../../utils/buttonLeft';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
}));

const ChangeRepresentante = (props) => {
    const userId = useSelector(state => state.account.user?._id);
    const representante = useSelector(state => state.dadosRepresentante?.data)
    const [open, setOpen] = useState(false);
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')

    const handleClose = () => {
        props.setOpen(false);
    };

    const handleChange = () => {
        setMessageSuccess('')
        setMessageError('')
        setOpen(true)

        api.put('/empresa/edit',  { 
            'empresaId': props.empresa?._id, 
            'representanteId': representante?._id, 
            userId 
        })
            .then(response => {
                // console.log(response) 
                setOpen(false)
                setMessageSuccess('Mudança feita com sucesso.')

                setTimeout(() => {
                    // navigate(-1)
                    window.location.reload()
                }, 5000);

            }).catch(err => {
                // console.log(err)
                setOpen(false)
                setMessageError('Erro ao salvar')
            })
    }

    return (
        <>
            <BootstrapDialog
                scroll='body'
                maxWidth={'md'}
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={props.open}
            >
                <div style={{ padding: 20 }}>

                    {messageSuccess && <MessageSuccess message={messageSuccess} />}
                    {messageError && <MessageError message={messageError} />}
                    <Typography>
                       <strong>REPRESENTANTE ACTUAL</strong>
                    </Typography>

                    <FichaRepresentante representante={props.empresa?.representante}/>

                    <Typography >
                     <strong> NOVO REPRESENTANTE </strong>
                    </Typography>

                    <StepCadastroRepresentante changeRepresentante={true}/>

                    <ButtonLeft
                        title={'salvar'}
                        funcao={handleChange}
                        load={open}
                        disabled={!representante}
                    >
                        <Button color='error' onClick={handleClose} size="small">
                            Cancelar
                        </Button>

                    </ButtonLeft>
                </div>
            </BootstrapDialog>
        </>
    );
}

export default ChangeRepresentante;
